<div class="min-h-screen bg-gray-50 p-4 md:p-8">
  <h2 class="text-2xl md:text-3xl font-semibold text-center text-[#c19725] mb-8">
    Ready Product Reports
  </h2>

  <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-8xl mx-auto">

    <!-- Piece Wise Report Card -->
    <div
      class="bg-orange-100 rounded-2xl shadow-md hover:shadow-xl transition duration-300 cursor-pointer overflow-hidden group"
      routerLink="/report/ready-products/piece"
    >
      <div class="h-48 overflow-hidden">
        <img
          src="https://cdn-icons-png.flaticon.com/512/2921/2921222.png"
          alt="Piece Wise Report"
          class="w-full h-full object-contain p-6 group-hover:scale-110 transition duration-300"
        />
      </div>

      <div class="p-5 text-center">
        <h3 class="text-lg font-semibold text-gray-700 mb-2">
          Piece Wise Report
        </h3>
      </div>
    </div>

    <!-- Lot Wise Report Card -->
    <div
      class="bg-blue-100 rounded-2xl shadow-md hover:shadow-xl transition duration-300 cursor-pointer overflow-hidden group"
      routerLink="/report/ready-products/lot"
    >
      <div class="h-48 overflow-hidden">
        <img
          src="https://cdn-icons-png.flaticon.com/512/3135/3135679.png"
          alt="Lot Wise Report"
          class="w-full h-full object-contain p-6 group-hover:scale-110 transition duration-300"
        />
      </div>

      <div class="p-5 text-center">
        <h3 class="text-lg font-semibold text-gray-700 mb-2">
          Lot Wise Report
        </h3>
      </div>
    </div>

    <div
      class="bg-orange-100 rounded-2xl shadow-md hover:shadow-xl transition duration-300 cursor-pointer overflow-hidden group"
      routerLink="/report/non-jewellery-product-list"
    >
      <div class="h-48 overflow-hidden">
        <img
          src="https://cdn-icons-png.flaticon.com/512/3144/3144456.png"
          alt="Product Report"
          class="w-full h-full object-contain p-6 group-hover:scale-110 transition duration-300"
        />
      </div>
    
      <div class="p-5 text-center">
        <h3 class="text-lg font-semibold text-gray-700 mb-2">
          Product Report
        </h3>
      </div>
    </div>
  </div>
</div>
